// Optional because a precise location's coordinates are nullable in the schema; callers check
// they have a point before grouping by it.
interface ICoordinates {
  longitude?: number
  latitude?: number
}

const SEPARATOR = ','

// The grouping key every pin set shares. All three are read back through the same
// groupsByCoordKey lookup and the same GL hit-test, so the format has to be one thing: a change
// here — rounding the coordinates so float drift stops splitting a group, say — reaches all of
// them. The scope is what a set groups WITHIN: the marker a delivery pin hangs off, the kind of a
// shared entity, nothing for workflow pins, which group by coordinate alone.
export function pinCoordKey(
  coord: ICoordinates,
  scope?: string | number,
): string {
  const coordinates = `${coord.longitude}${SEPARATOR}${coord.latitude}`
  return scope == null ? coordinates : `${scope}${SEPARATOR}${coordinates}`
}
